import { safeGet } from "@app/shared/utils/secure/safe-get";
import { createSelector } from "@ngrx/store";
import { selectWorkingGroupState } from "../reducers";
import * as fromWorkingGroup from "../reducers/working-group.reducer";

export const selectWorkingGroupListIsLoading = () =>
  createSelector(selectWorkingGroupState(), fromWorkingGroup.selectIsLoading);

export const selectWorkingGroupEntities = () =>
  createSelector(
    selectWorkingGroupState(),
    fromWorkingGroup.selectWorkingGroupEntities,
  );

export const selectAllWorkingGroups = () =>
  createSelector(
    selectWorkingGroupState(),
    fromWorkingGroup.selectAllWorkingGroups,
  );

export const selectWorkingGroupById = (id: number) =>
  createSelector(selectWorkingGroupEntities(), (workingGroupEntities) =>
    safeGet(workingGroupEntities, String(id)),
  );
